import { loadModal } from './loadModal';
import { chatSettings } from '../components/chatSettings';

function showSettingsModal(element) {
    if (window.growtypeModal?.show) {
        window.growtypeModal.show(element);
    } else {
        $(element).modal('show');
    }
}

export function chatSettingsBtn(element = $('.btn-chat-settings, .g-chat-btn-editchat')) {
    // The shared theme listens for Bootstrap modal attributes globally. The
    // settings modal is intentionally absent until requested, so remove those
    // attributes before a click can trigger the generic missing-modal loader.
    element.removeAttr('data-bs-toggle data-bs-target');
    element.off('click.lazyChatSettings').on('click.lazyChatSettings', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const existing = document.getElementById('growtypeChatSettingsModal');
        if (existing) {
            showSettingsModal(existing);
            return;
        }

        const placeholder = $('.growtype-chat-settings-modal-placeholder').first();
        const chatForm = $(this).closest('.g-chatform');
        const sessionToken = placeholder.data('session-token') || chatForm.attr('data-session-token') || '';
        const userToken = placeholder.data('user-token') || chatForm.attr('data-user-token') || '';
        const roleplayOptionLimit = placeholder.data('roleplay-option-limit') || 8;
        const trigger = $(this);

        trigger.prop('disabled', true);
        const action = growtype_chat_ajax.get_chat_settings_modal_action || 'growtype_chat_get_chat_settings_modal';
        loadModal(action, null, {
            modalId: 'growtypeChatSettingsModal',
            ajaxData: {
                session_token: sessionToken,
                user_token: userToken,
                roleplay_option_limit: roleplayOptionLimit,
            },
        }).then(function ($modal) {
            placeholder.remove();
            chatSettings();
            document.dispatchEvent(new CustomEvent('growtypeChatSettingsModalLoaded'));
            showSettingsModal($modal[0]);
        }).catch(function (error) {
            console.error(error);
        }).finally(function () {
            trigger.prop('disabled', false);
        });
    });
}
